export default {
  logging_out: 'Proses logout',
  logging_out_failed: 'Gagal logout',
  logging_out_success: 'Berhasil logout',
  logging_in_success: 'Berhasil login',
  user_has_been_deactivated:
  'Akun anda telah dinonaktifkan, silahkan hubungi admin kami untuk mengaktifkan kembali akun anda',
};
